var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('telephone-field',_vm._b({model:{value:(_vm.telephone),callback:function ($$v) {_vm.telephone=$$v},expression:"telephone"}},'telephone-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }